'use strict';

/* eslint no-undef: "off" */
/**
 * XPark pre-launch card
 */
define('xparkPreLaunch',['swiper', 'bottomSheet', 'svgIcon', 'getCityListApi', 'xparkHomepageApi', 'busEvent', 'appStorage'], function (Swiper, bottomSheet, svgIcon, getCityListApi, xparkHomepageApi, busEvent, appStorage) {
  return {
    template: '\n      <section class="xp-pre-launch" v-if="reserveItems.length">\n        <div v-if="loading" class="skeleton-loading"></div>\n        <div v-if="reserveItems.length" class="xp-pre-launch-swiper swiper-container" ref="preLaunchSwiper">\n          <div class="swiper-wrapper">\n            <div\n              v-for="(item, index) in reserveItems"\n              :key="item.id || index"\n              class="xp-pre-launch-slide swiper-slide"\n            >\n              <div class="xp-pre-launch-card">\n                <img :src="require.toUrl(\'images/pre_launch_bg.png\')" class="xp-pre-launch-bg" />\n                <div class="xp-pre-launch-head">\n                  <h2 v-text="item.reserveName"></h2>\n                  <div class="xp-pre-launch-countdown" aria-label="Pre-launch countdown">\n                    <span v-text="countdownList[index].days + \'d\'"></span>\n                    <i>:</i>\n                    <span v-text="countdownList[index].hours + \'h\'"></span>\n                    <i>:</i>\n                    <span v-text="countdownList[index].minutes + \'m\'"></span>\n                  </div>\n                </div>\n\n                <div class="xp-pre-launch-hero">\n                  <img class="xp-pre-launch-phone" :src="item.bannerImage" :alt="item.productName" />\n                </div>\n\n                <div class="xp-pre-launch-product">\n                  <div class="xp-pre-launch-thumb">\n                    <img :src="item.productImage" :alt="item.productName" />\n                  </div>\n                  <div class="xp-pre-launch-detail">\n                    <h3 v-text="item.productName"></h3>\n                    <ul>\n                      <li v-for="point in item.salesPoints" :key="point" v-text="point"></li>\n                    </ul>\n                  </div>\n                </div>\n\n                <a\n                  v-if="item.targetLink"\n                  class="xp-pre-launch-button"\n                  target="_blank"\n                  :href="item.targetLink"\n                >\n                  Reserve Now\n                </a>\n                <button\n                  v-else\n                  class="xp-pre-launch-button"\n                  type="button"\n                  @click="showReserveModal"\n                >\n                  Reserve Now\n                </button>\n\n                <p class="xp-pre-launch-confirm" v-if="!item.targetLink">\n                  <span>Order Confirmation:</span>\n                  <strong v-text="item.joinCount"></strong>\n                </p>\n              </div>\n            </div>\n          </div>\n          <div\n            v-if="reserveItems.length > 1"\n            class="xp-pre-launch-pagination swiper-pagination"\n          ></div>\n        </div>\n\n        <transition v-if="reserveItems.length" name="xp-pre-launch-fade">\n          <div class="xp-reserve-modal" v-if="isModalVisible">\n            <div class="xp-reserve-backdrop" @click="hideReserveModal"></div>\n            <div class="xp-reserve-dialog" role="dialog" aria-modal="true" aria-labelledby="reserve-title">\n              <button class="xp-reserve-close" type="button" aria-label="Close" @click="hideReserveModal"></button>\n              <div class="xp-reserve-illustration" aria-hidden="true">\n                <img :src="require.toUrl(\'images/form_image.png\')" />\n              </div>\n              <h3 id="reserve-title">Leave Your Contact Information</h3>\n              <form class="xp-reserve-form" @submit.prevent="submitReserve">\n                <label class="xp-reserve-field" :class="{ \'is-error\': errors.name }">\n                  <span>*</span>\n                  <input type="text" placeholder="Name" v-model="form.name" @input="clearError(\'name\')" />\n                </label>\n                <label class="xp-reserve-field" :class="{ \'is-error\': errors.phone }">\n                  <span>*</span>\n                  <input type="tel" placeholder="Mobile" v-model="form.phone" @input="clearError(\'phone\')" />\n                </label>\n                <label class="xp-reserve-field" :class="{ \'is-error\': errors.email }">\n                  <span>*</span>\n                  <input type="email" placeholder="Email" v-model="form.email" @input="clearError(\'email\')" />\n                </label>\n                <label class="xp-reserve-field xp-reserve-field-button" :class="{ \'is-error\': errors.city }">\n                  <span>*</span>\n                  <button type="button" class="xp-reserve-city-trigger" @click="openCitySheet">\n                    <div\n                      class="xp-reserve-field-value"\n                      :class="{ \'is-placeholder\': !selectedCityText }"\n                      v-text="selectedCityText || \'Select City\'"></div>\n                    <svg-icon type="arrowRight"></svg-icon>\n                  </button>\n                </label>\n                <label class="xp-reserve-field" :class="{ \'is-error\': errors.address }">\n                  <span>*</span>\n                  <input type="text" placeholder="Address" v-model="form.address" @input="clearError(\'address\')" />\n                </label>\n                <label class="xp-reserve-agree" :class="{ \'is-error\': errors.agree }">\n                  <input type="checkbox" v-model="form.agree" @change="clearError(\'agree\')" />\n                  <span class="xp-reserve-agree-icon">\n                    <svg-icon :type="form.agree ? \'checkForm\' : \'notcheckForm\'"></svg-icon>\n                  </span>\n                  <span class="xp-reserve-agree-text">\n                    By submitting, you agree to our\n                    <a href="/privacy-policy" target="_blank">Privacy Policy</a>\n                    and consent to receive updates.\n                  </span>\n                </label>\n                <button class="xp-reserve-confirm" :class="{ \'is-disabled\': !isFormReady }" :disabled="!isFormReady" type="submit">Confirm</button>\n              </form>\n            </div>\n\n            <bottom-sheet\n              :visible="activeSheet === \'city\'"\n              title="City"\n              sheet-class="xp-bottom-sheet-tall xp-city-sheet"\n              @close="closeSheet"\n              @confirm="confirmCity">\n              <template slot="header">\n                <div class="xp-city-tabs">\n                  <button type="button" :class="{active: cityStep === \'area\'}" @click="cityStep = \'area\'" v-text="cityAreaTabText"></button>\n                  <button type="button" :class="{active: cityStep === \'city\'}" @click="cityStep = \'city\'" v-text="cityCityTabText"></button>\n                </div>\n              </template>\n              <div class="xp-city-select-wrap">\n                <div class="xp-select-list xp-city-list" ref="cityListScroller">\n                  <div class="xp-city-group" v-for="group in cityGroups" :key="group.letter">\n                    <p class="xp-city-letter" :data-city-letter="group.letter" v-text="group.letter"></p>\n                    <button\n                      type="button"\n                      class="xp-select-row"\n                      :class="{active: isCityOptionSelected(item)}"\n                      v-for="item in group.items"\n                      :key="(item.id || item.name || item.text || group.letter) + \'-\' + cityStep"\n                      @click="selectCityOption(item)">\n                      <span class="xp-select-row-label" v-text="item.name || item.text"></span>\n                      <svg-icon v-if="isCityOptionSelected(item)" type="check"></svg-icon>\n                    </button>\n                  </div>\n                </div>\n                <div class="xp-city-index" v-if="cityGroups.length > 1">\n                  <button type="button" v-for="group in cityGroups" :key="group.letter" @click="scrollToCityLetter(group.letter)" v-text="group.letter"></button>\n                </div>\n              </div>\n            </bottom-sheet>\n          </div>\n        </transition>\n      </section>\n    ',
    components: {
      bottomSheet: bottomSheet,
      svgIcon: svgIcon
    },
    data: function data() {
      return {
        reserveItems: [],
        preLaunchSlider: null,
        preLaunchSliderTimer: null,
        activeSlideIndex: 0,
        countdownTimer: null,
        nowTimestamp: Date.now(),
        isModalVisible: false,
        activeSheet: '',
        cityStep: 'area',
        areaList: [],
        curArea: null,
        curCity: null,
        draftArea: null,
        draftCity: null,
        form: {
          name: '',
          phone: '',
          email: '',
          city: '',
          address: '',
          agree: false
        },
        errors: {
          name: false,
          phone: false,
          email: false,
          city: false,
          address: false,
          agree: false
        },
        loading: false
      };
    },
    created: function created() {
      var data = appStorage.get("reserveList");
      if (data) {
        this.reserveItems = JSON.parse(data);
      }
    },
    mounted: function mounted() {
      this.fetchReserveList();
      this.getCityList();
    },
    beforeDestroy: function beforeDestroy() {
      if (this.preLaunchSliderTimer) {
        window.clearTimeout(this.preLaunchSliderTimer);
      }

      if (this.preLaunchSlider && this.preLaunchSlider.destroy) {
        this.preLaunchSlider.destroy(true, true);
      }

      if (this.countdownTimer) {
        window.clearInterval(this.countdownTimer);
      }
    },

    computed: {
      reserveItem: function reserveItem() {
        return this.reserveItems[this.activeSlideIndex] || null;
      },
      countdownList: function countdownList() {
        var _this = this;

        return this.reserveItems.map(function (item) {
          return _this.getCountdownData(item);
        });
      },
      selectedCityText: function selectedCityText() {
        var areaName = this.curArea && (this.curArea.name || this.curArea.text);
        var cityName = this.curCity && (this.curCity.name || this.curCity.text);

        if (areaName && cityName) {
          return areaName + ' / ' + cityName;
        }

        return cityName || areaName || this.form.city;
      },
      cityAreaTabText: function cityAreaTabText() {
        if (this.cityStep === 'city') {
          return this.draftArea && (this.draftArea.name || this.draftArea.text) || 'Select Region';
        }

        return 'Select Region';
      },
      cityCityTabText: function cityCityTabText() {
        return 'Select City';
      },
      cityOptions: function cityOptions() {
        if (this.cityStep === 'city') {
          return this.getChildren(this.draftArea);
        }

        return this.areaList;
      },
      cityGroups: function cityGroups() {
        return this.groupByLetter(this.cityOptions);
      },
      isFormReady: function isFormReady() {
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        var name = String(this.form.name || '').trim();
        var phone = String(this.form.phone || '').trim();
        var email = String(this.form.email || '').trim();
        var address = String(this.form.address || '').trim();
        var city = this.selectedCityText || String(this.form.city || '').trim();

        return !!(name && phone && emailPattern.test(email) && city && address && this.form.agree);
      }
    },
    methods: {
      fetchReserveList: function fetchReserveList() {
        var _this2 = this;

        this.loading = true;
        xparkHomepageApi.getReserveList().then(function (data) {
          if (!Array.isArray(data) || !data.length) {
            return;
          }

          var list = data.map(function (item) {
            return _this2.normalizeReserveItem(item);
          }).filter(function (item) {
            return item.id || item.productName || item.bannerImage || item.productImage;
          });

          if (!list.length) {
            return;
          }

          var initialIndex = Math.max(0, list.findIndex(function (item) {
            return item.enabled;
          }));

          _this2.reserveItems = list;
          _this2.activeSlideIndex = initialIndex;
          _this2.startCountdown();
          _this2.$nextTick(_this2.resetPreLaunchSlider);
          appStorage.set("reserveList", JSON.stringify(list));
        }).catch(function () {}).finally(function () {
          return _this2.loading = false;
        });
      },
      normalizeReserveItem: function normalizeReserveItem(item) {
        return {
          id: item.id,
          enabled: String(item.enabled) === '1',
          reserveName: item.reserve_name || 'PRE-LAUNCH',
          productName: item.product_name || '',
          startAt: item.start_at || '',
          endAt: item.end_at || '',
          productImage: item.product_image || '',
          bannerImage: item.banner_image || item.product_image || '',
          joinCount: item.join_count || '0',
          targetLink: item.target_link || '',
          salesPoints: Array.isArray(item.sales_points) ? item.sales_points.map(function (point) {
            return String(point).trim();
          }).filter(Boolean) : []
        };
      },
      resetPreLaunchSlider: function resetPreLaunchSlider() {
        if (this.preLaunchSliderTimer) {
          window.clearTimeout(this.preLaunchSliderTimer);
          this.preLaunchSliderTimer = null;
        }

        if (this.preLaunchSlider && this.preLaunchSlider.destroy) {
          this.preLaunchSlider.destroy(true, true);
          this.preLaunchSlider = null;
        }

        this.initPreLaunchSlider();
      },
      initPreLaunchSlider: function initPreLaunchSlider() {
        var _this3 = this;

        var container = this.$refs.preLaunchSwiper;

        if (!container || !this.reserveItems.length) {
          return;
        }

        this.preLaunchSliderTimer = window.setTimeout(function () {
          var sliderOptions = {
            initialSlide: _this3.activeSlideIndex,
            loop: _this3.reserveItems.length > 1,
            loopAdditionalSlides: _this3.reserveItems.length,
            loopedSlides: _this3.reserveItems.length,
            observer: true,
            observeParents: true,
            slidesPerView: 'auto',
            spaceBetween: 0,
            speed: 350,
            on: {
              slideChange: function slideChange() {
                _this3.activeSlideIndex = _this3.preLaunchSlider ? _this3.preLaunchSlider.realIndex : 0;
              }
            }
          };

          if (_this3.reserveItems.length > 1) {
            sliderOptions.pagination = {
              el: '.xp-pre-launch-pagination',
              clickable: true
            };
          }

          _this3.preLaunchSlider = new Swiper(container, sliderOptions);
        }, 20);
      },
      startCountdown: function startCountdown() {
        var _this4 = this;

        this.nowTimestamp = Date.now();

        if (this.countdownTimer) {
          window.clearInterval(this.countdownTimer);
        }

        this.countdownTimer = window.setInterval(function () {
          _this4.nowTimestamp = Date.now();
        }, 60000);
      },
      getCountdownData: function getCountdownData(item) {
        var endTime = this.parseTimeValue(item && item.endAt);
        var diff = Math.max(0, endTime - this.nowTimestamp);
        var minutes = Math.floor(diff / 60000);

        return {
          days: Math.floor(minutes / 1440),
          hours: Math.floor(minutes % 1440 / 60),
          minutes: minutes % 60
        };
      },
      parseTimeValue: function parseTimeValue(value) {
        var timeString = String(value || '').trim();

        if (!timeString) {
          return 0;
        }

        if (/^\d+$/.test(timeString)) {
          return timeString.length === 10 ? Number(timeString) * 1000 : Number(timeString);
        }

        return new Date(timeString.replace(/-/g, '/')).getTime() || 0;
      },
      showReserveModal: function showReserveModal() {
        this.isModalVisible = true;
        this.clearErrors();
      },
      hideReserveModal: function hideReserveModal() {
        this.closeSheet();
        this.isModalVisible = false;
      },
      openCitySheet: function openCitySheet() {
        var _this5 = this;

        this.draftArea = this.curArea || this.areaList[0] || null;
        this.draftCity = this.curCity || this.getDefaultCity(this.draftArea);
        this.cityStep = 'area';
        this.activeSheet = 'city';
        this.clearError('city');
        this.$nextTick(function () {
          _this5.resetCityScroll();
        });
      },
      closeSheet: function closeSheet() {
        this.activeSheet = '';
      },
      getCityList: function getCityList() {
        var _this6 = this;

        getCityListApi().then(function (resData) {
          _this6.areaList = Array.isArray(resData) ? resData : [];
          _this6.filterDefaultCity();
        }).catch(function () {
          _this6.areaList = [];
        });
      },
      filterDefaultCity: function filterDefaultCity() {
        var _this7 = this;

        var defaultArea = this.areaList[0] || null;
        var defaultCity = this.getDefaultCity(defaultArea);

        this.areaList.forEach(function (area) {
          if (_this7.isDefault(area)) {
            defaultArea = area;
            defaultCity = _this7.getDefaultCity(area);
          }
        });

        this.curArea = defaultArea;
        this.curCity = defaultCity;
        this.syncCityFormValue();
      },
      getDefaultCity: function getDefaultCity(area) {
        var _this8 = this;

        var children = this.getChildren(area);
        var defaultCity = children[0] || null;

        children.forEach(function (city) {
          if (_this8.isDefault(city)) {
            defaultCity = city;
          }
        });

        return defaultCity;
      },
      getChildren: function getChildren(area) {
        return area && Array.isArray(area.children) ? area.children : [];
      },
      isDefault: function isDefault(item) {
        return item && (item.is_default === true || item.is_default === 1 || item.is_default === '1' || item.isChecked === true || item.isChecked === 1 || item.isChecked === '1');
      },
      selectCityOption: function selectCityOption(item) {
        var _this9 = this;

        if (this.cityStep === 'area') {
          this.draftArea = item;
          this.draftCity = this.getDefaultCity(item);
          this.cityStep = 'city';
          this.$nextTick(function () {
            _this9.resetCityScroll();
          });
          return;
        }

        this.draftCity = item;
      },
      isCityOptionSelected: function isCityOptionSelected(item) {
        if (this.cityStep === 'area') {
          return this.draftArea === item;
        }

        return this.draftCity === item;
      },
      confirmCity: function confirmCity() {
        this.curArea = this.draftArea;
        this.curCity = this.draftCity;
        this.syncCityFormValue();
        this.clearError('city');
        this.closeSheet();
      },
      syncCityFormValue: function syncCityFormValue() {
        this.form.city = this.selectedCityText || '';
      },
      clearError: function clearError(field) {
        this.errors[field] = false;
      },
      clearErrors: function clearErrors() {
        var _this10 = this;

        Object.keys(this.errors).forEach(function (key) {
          _this10.errors[key] = false;
        });
      },
      normalizeForm: function normalizeForm() {
        this.form.name = String(this.form.name || '').trim();
        this.form.phone = String(this.form.phone || '').trim();
        this.form.email = String(this.form.email || '').trim();
        this.form.address = String(this.form.address || '').trim();
        this.syncCityFormValue();
      },
      validateForm: function validateForm() {
        var _this11 = this;

        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        this.normalizeForm();
        this.clearErrors();

        this.errors.name = !this.form.name;
        this.errors.phone = !this.form.phone;
        this.errors.email = !this.form.email || !emailPattern.test(this.form.email);
        this.errors.city = !this.form.city;
        this.errors.address = !this.form.address;
        this.errors.agree = !this.form.agree;

        return !Object.keys(this.errors).some(function (key) {
          return _this11.errors[key];
        });
      },
      submitReserve: function submitReserve() {
        var _this12 = this;

        if (!this.reserveItem) {
          return;
        }

        if (!this.validateForm()) {
          busEvent.$emit('modalError', 'Please complete the required fields');
          return;
        }

        xparkHomepageApi.submitReserve({
          reserve_id: Number(this.reserveItem.id),
          firstname: this.form.name,
          mobile: this.form.phone,
          email: this.form.email
        }).then(function () {
          _this12.resetForm();
          _this12.hideReserveModal();
          busEvent.$emit('showPopBoxUpEvent', 'Submitted successfully');
        }).catch(function () {});
      },
      resetForm: function resetForm() {
        this.form = {
          name: '',
          phone: '',
          email: '',
          city: '',
          address: '',
          agree: false
        };
        this.clearErrors();
        this.filterDefaultCity();
      },
      groupByLetter: function groupByLetter(list) {
        var _this13 = this;

        var groups = [];
        var groupMap = {};(list || []).forEach(function (item) {
          var letter = _this13.getItemLetter(item);

          if (!groupMap[letter]) {
            groupMap[letter] = {
              letter: letter,
              items: []
            };
            groups.push(groupMap[letter]);
          }

          groupMap[letter].items.push(item);
        });

        return groups.sort(function (a, b) {
          return a.letter.localeCompare(b.letter);
        });
      },
      getItemLetter: function getItemLetter(item) {
        var letter = item && (item.letter || item.first_letter || item.initial || item.index);
        var name = item && (item.name || item.text || '');

        if (!letter && name) {
          letter = name.charAt(0);
        }

        letter = String(letter || '#').charAt(0).toUpperCase();
        return (/^[A-Z0-9]$/.test(letter) ? letter : '#'
        );
      },
      scrollToCityLetter: function scrollToCityLetter(letter) {
        var scroller = this.$refs.cityListScroller;
        var target = this.$el.querySelector('[data-city-letter="' + letter + '"]');

        if (scroller && target) {
          scroller.scrollTop = target.offsetTop - scroller.offsetTop;
        }
      },
      resetCityScroll: function resetCityScroll() {
        if (this.$refs.cityListScroller) {
          this.$refs.cityListScroller.scrollTop = 0;
        }
      }
    }
  };
});
